/**
 * The studio's default review target (e.g. 10–50) is a per-studio preference,
 * not a per-link one, so a 4-photo link would otherwise tell the client to
 * "aim for 10–50". Hide the target when the gallery cannot reach its floor,
 * and never ask for more picks than there are photos.
 */
export function effectiveReviewTarget(
  target: { min: number; max: number } | null | undefined,
  photoCount: number
): { min: number; max: number } | null {
  if (!target || target.min <= 0 || photoCount < target.min) return null
  return { min: target.min, max: Math.min(target.max, photoCount) }
}
